let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8A7Un")).then(() => parcelRequire('bxHzv'));